/* Yatas Bedding NL — footer column accordions.
 *
 * The reference collapses each footer column behind a chevron on mobile and
 * shows every link on desktop. The heading is always a <button>; this only
 * toggles it while the accordion breakpoint is active, and forces every column
 * back open when the viewport grows past it.
 */
(function () {
  'use strict';

  const MQ = window.matchMedia('(max-width: 991px)');

  function buttons() {
    return Array.from(document.querySelectorAll('[data-footer-acc]'));
  }

  function sync() {
    // Above the breakpoint the panels are shown by CSS regardless, but the
    // aria state should still describe what the user can see.
    buttons().forEach((b) => {
      b.setAttribute('aria-expanded', MQ.matches ? 'false' : 'true');
    });
  }

  function init() {
    buttons().forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!MQ.matches) return;
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
      });
    });

    sync();
    if (MQ.addEventListener) MQ.addEventListener('change', sync);
    else MQ.addListener(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
